export const REQUEST_SINGLE_LIST_DETAILS = "REQUEST_SINGLE_LIST_DETAILS";
export const SET_SINGLE_LIST_DETAILS = "SET_SINGLE_LIST_DETAILS";
export const REVOKE_SINGLE_LIST_DETAILS = "REVOKE_SINGLE_LIST_DETAILS";
export const RESET_SINGLE_LIST_DETAILS = "RESET_SINGLE_LIST_DETAILS";

export const REQUEST_SINGLE_LIST_RESPONSES = "REQUEST_SINGLE_LIST_RESPONSE";
export const SET_SINGLE_LIST_RESPONSES = "SET_SINGLE_LIST_RESPONSE";
export const REVOKE_SINGLE_LIST_RESPONSE = "REVOKE_SINGLE_LIST_RESPONSE";
export const RESET_SINGLE_LIST_RESPONSE = "RESET_SINGLE_LIST_RESPONSE";

export const REQUEST_ADD_LIST_COMPANY_RESPONSE =
  "REQUEST_ADD_LIST_COMPANY_RESPONSE";
export const GRANT_ADD_LIST_COMPANY_RESPONSE =
  "GRANT_ADD_LIST_COMPANY_RESPONSE";
export const REVOKE_ADD_LIST_COMPANY_RESPONSE =
  "REVOKE_ADD_LIST_COMPANY_RESPONSE";
export const RESET_ADD_LIST_COMPANY_RESPONSE =
  "RESET_ADD_LIST_COMPANY_RESPONSE";

export const REQUEST_SET_ACTIVE_COMPANY_DETAILS =
  "REQUEST_SET_ACTIVE_COMPANY_DETAILS";
export const GRANT_SET_ACTIVE_COMPANY_DETAILS =
  "GRANT_SET_ACTIVE_COMPANY_DETAILS";
export const REVOKE_SET_ACTIVE_COMPANY_DETAILS =
  "REVOKE_SET_ACTIVE_COMPANY_DETAILS";
export const RESET_SET_ACTIVE_COMPANY_DETAILS =
  "RESET_SET_ACTIVE_COMPANY_DETAILS";

export const REQUEST_SET_ACTIVE_COMPANY_NOTES =
  "REQUEST_SET_ACTIVE_COMPANY_NOTES";
export const GRANT_SET_ACTIVE_COMPANY_NOTES = "GRANT_SET_ACTIVE_COMPANY_NOTES";
export const REVOKE_SET_ACTIVE_COMPANY_NOTES =
  "REVOKE_SET_ACTIVE_COMPANY_NOTES";
export const RESET_SET_ACTIVE_COMPANY_NOTES = "RESET_SET_ACTIVE_COMPANY_NOTES";

export const REQUEST_REMOVE_LIST_COMPANY_NOTE =
  "REQUEST_REMOVE_LIST_COMPANY_NOTE";
export const GRANT_REMOVE_LIST_COMPANY_NOTE = "GRANT_REMOVE_LIST_COMPANY_NOTE";
export const REVOKE_REMOVE_LIST_COMPANY_NOTE =
  "REVOKE_REMOVE_LIST_COMPANY_NOTE";
export const RESET_REMOVE_LIST_COMPANY_NOTE = "RESET_REMOVE_LIST_COMPANY_NOTE";

export const REQUEST_ADD_LIST_COMPANY_NOTE = "REQUEST_ADD_LIST_COMPANY_NOTE";
export const GRANT_ADD_LIST_COMPANY_NOTE = "GRANT_ADD_LIST_COMPANY_NOTE";
export const REVOKE_ADD_LIST_COMPANY_NOTE = "REVOKE_ADD_LIST_COMPANY_NOTE";
export const RESET_ADD_LIST_COMPANY_NOTE = "RESET_ADD_LIST_COMPANY_NOTE";

export const REQUEST_LIST_COMPANY_STATUS = "REQUEST_LIST_COMPANY_STATUS";
export const SET_LIST_COMPANY_STATUS = "SET_LIST_COMPANY_STATUS";
export const REVOKE_LIST_COMPANY_STATUS = "REVOKE_LIST_COMPANY_STATUS";
export const RESET_LIST_COMPANY_STATUS = "RESET_LIST_COMPANY_STATUS";

export const REQUEST_CREATE_NEW_CLIENT = "REQUEST_CREATE_NEW_CLIENT";
export const GRANT_CREATE_NEW_CLIENT = "GRANT_CREATE_NEW_CLIENT";
export const REVOKE_CREATE_NEW_CLIENT = "REVOKE_CREATE_NEW_CLIENT";
export const RESET_CREATE_NEW_CLIENT = "RESET_CREATE_NEW_CLIENT";

export const REQUEST_REMOVE_EXISTING_CLIENT = "REQUEST_REMOVE_EXISTING_CLIENT";
export const GRANT_REMOVE_EXISTING_CLIENT = "GRANT_REMOVE_EXISTING_CLIENT";
export const REVOKE_REMOVE_EXISTING_CLIENT = "REVOKE_REMOVE_EXISTING_CLIENT";
export const RESET_REMOVE_EXISTING_CLIENT = "RESET_REMOVE_EXISTING_CLIENT";

export const REQUEST_CREATE_NEW_OPPORTUNITY = "REQUEST_CREATE_NEW_OPPORTUNITY";
export const GRANT_CREATE_NEW_OPPORTUNITY = "GRANT_CREATE_NEW_OPPORTUNITY";
export const REVOKE_CREATE_NEW_OPPORTUNITY = "REVOKE_CREATE_NEW_OPPORTUNITY";
export const RESET_CREATE_NEW_OPPORTUNITY = "RESET_CREATE_NEW_OPPORTUNITY";

export const REQUEST_CREATE_NEW_CONTACT = "REQUEST_CREATE_NEW_CONTACT";
export const GRANT_CREATE_NEW_CONTACT = "GRANT_CREATE_NEW_CONTACT";
export const REVOKE_CREATE_NEW_CONTACT = "REVOKE_CREATE_NEW_CONTACT";
export const RESET_CREATE_NEW_CONTACT = "RESET_CREATE_NEW_CONTACT";

export const REQUEST_COMPANY_DELETIONS = "REQUEST_COMPANY_DELETIONS";
export const SET_COMPANY_DELETIONS = "SET_COMPANY_DELETIONS";
export const REVOKE_COMPANY_DELETIONS = "REVOKE_COMPANY_DELETIONS";
export const RESET_COMPANY_DELETIONS = "RESET_COMPANY_DELETIONS";

export const REQUEST_REMOVE_COMPANY_LISTING = "REQUEST_REMOVE_COMPANY_LISTING";
export const GRANT_REMOVE_COMPANY_LISTING = "GRANT_REMOVE_COMPANY_LISTING";
export const REVOKE_REMOVE_COMPANY_LISTING = "REVOKE_REMOVE_COMPANY_LISTING";
export const RESET_REMOVE_COMPANY_LISTING = "RESET_REMOVE_COMPANY_LISTING";

export const SET_UPDATED_COMPANY_LIST = "SET_UPDATED_COMPANY_LIST";
export const RESET_UPDATED_COMPANY_LIST = "RESET_UPDATED_COMPANY_LIST";

export const CHANGE_SINGLE_LIST_MODALS = "CHANGE_SINGLE_LIST_MODALS";
export const SET_SINGLE_LIST_DISPLAY_INDEX = "SET_SINGLE_LIST_DISPLAY_INDEX";

export const REQUEST_FETCH_CONTACT_LISTS = "REQUEST_FETCH_CONTACT_LISTS";
export const GRANT_FETCH_CONTACT_LISTS = "GRANT_FETCH_CONTACT_LISTS";
export const REVOKE_FETCH_CONTACT_LISTS = "REVOKE_FETCH_CONTACT_LISTS";
export const RESET_FETCH_CONTACT_LISTS = "RESET_FETCH_CONTACT_LISTS";
